module.exports = __webpack_public_path__ + "static/media/IMG_mountain.ade1dd5b.JPG";